export default __webpack_public_path__ + "static/media/glasses.9ad99888.svg";